import { render, staticRenderFns } from "./DetailBagageClientType.vue?vue&type=template&id=45f8bd17&scoped=true"
import script from "./DetailBagageClientType.vue?vue&type=script&lang=js"
export * from "./DetailBagageClientType.vue?vue&type=script&lang=js"
import style0 from "./DetailBagageClientType.vue?vue&type=style&index=0&id=45f8bd17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8bd17",
  null
  
)

export default component.exports